export const createFilterParam = (type: string, name: string, symbol: '_' | '=') =>
  `${encodeURIComponent(type)}${symbol}${encodeURIComponent(name)}`;
